module.exports = __webpack_public_path__ + "static/media/edit.2118d235.svg";